import { FC, useState } from 'react';
import { PointsResponse } from 'src/api/me/types';
import levelUpAnimation from './assets/level-up-animation.json';
import { LevelUpCelebration } from './LevelUpCelebration';
import { StageUpCelebration } from './StageUpCelebration';

export { levelUpAnimation };

export const LevelAndStageCelebrations: FC<{
  targetLanguageName: string;
  pointsBefore: PointsResponse;
  pointsAfter: PointsResponse;
  onContinue: () => void;
}> = ({ targetLanguageName, pointsBefore, pointsAfter, onContinue }) => {
  const [levelUpCelebrationClosed, setLevelUpCelebrationClosed] = useState(false);
  const [showStageUpCelebration, setShowStageUpCelebration] = useState(false);

  return (
    <>
      <LevelUpCelebration
        languageName={targetLanguageName}
        level={pointsAfter.level.currentLevel}
        onClickContinue={() => {
          setLevelUpCelebrationClosed(true);
          if (pointsAfter.stage.stageName !== pointsBefore.stage.stageName) {
            setShowStageUpCelebration(true);
          } else {
            onContinue();
          }
        }}
        points={pointsAfter.points.totalPoints}
        isOpen={!levelUpCelebrationClosed}
      />
      <StageUpCelebration
        level={pointsAfter.level.currentLevel}
        onClickContinue={() => {
          setShowStageUpCelebration(false);
          onContinue();
        }}
        stageDescription={pointsAfter.stage.stageDescription}
        stageName={pointsAfter.stage.stageName}
        isOpen={showStageUpCelebration}
      />
    </>
  );
};
